<div [innerHTML]="jsonLD"></div>

<div class="jobsearch-job-subheader" style="background:url({{job.user?.cover_photo}}) center/cover no-repeat">
  <span class="jobsearch-banner-transparent" style="background: rgb(48, 56, 68, 0.50)"></span>
</div>

<div class="jobsearch-main-content">

  <div class="jobsearch-main-section">
    <div class="jobsearch-plugin-default-container">
      <div class="jobsearch-row">

        <div class="jobsearch-column-12">
          <div class="jobsearch-typo-wrap">
            <figure class="jobsearch-jobdetail-list">
              <span class="jobsearch-jobdetail-listthumb">
                <img [src]="job.user?.profile_photo" alt="">
              </span>
              <figcaption>
                <h2>{{job.title}}</h2>
                <span>
                  <small> <a class="jobsearch-jobdetail-type" [class]="job.job_type">
                      {{getJobType(job)}} </a>
                  </small><a [routerLink]="['/user-details/', job.user?.username]">{{job.user?.username}}</a>
                  <small class="jobsearch-jobdetail-postinfo"> posted {{job.created_at | timeAgo}}</small>
                  <small class="post-in-category"> in <a [routerLink]="['/jobs']"
                      [queryParams]="{sector: job.job_sector_id}" class="" [innerHTML]="job.job_sector">
                    </a>
                  </small>
                </span>
                <ul class="jobsearch-jobdetail-options">
                  <li>
                    <i class="fa fa-map-marker"></i> {{ {address:job.address,
                    city:job.city, state:job.state, country:job.country } | jobFullAddress}}
                    <a *ngIf="job.latitude && job.longitude"
                      href="https://www.google.com/maps/search/{{job.latitude}}%2C{{job.longitude}}" target="_blank"
                      class="jobsearch-jobdetail-view">View on Map</a>
                  </li>
                  <li>
                    <i class="jobsearch-icon jobsearch-calendar"></i> Post Date : {{job.created_at | date:'MMM d, y'}}
                  </li>
                  <li>
                    <i class="careerfy-icon careerfy-calendar"></i> Apply Before : {{job.deadline | date:'MMM d, y'}}
                  </li>
                  <li>
                    <a><i class="jobsearch-icon jobsearch-view"></i> View(s) {{job.views}} </a>
                  </li>
                </ul>

                <a (click)="updateFavoriteJob()" class="jobsearch-add-job-to-favourite careerfy-jobdetail-btn active">
                  {{isJobFavorite ? 'Shortlisted' : 'Shortlist'}} </a>

                <a (click)="emailJob()" class=" active jobsearch-send-email-popup-btn"><i
                    class="jobsearch-icon jobsearch-envelope"></i> Email Job </a>

                <ul class="jobsearch-jobdetail-media">
                  <li><span>Share:</span></li>
                  <li><a shareButton="facebook"
                      class="jobsearch-icon jobsearch-facebook-logo-in-circular-button-outlined-social-symbol addthis_button_facebook at300b"
                      title="Facebook">

                      <span class="at-icon-wrapper"
                        style="background-color: rgb(59, 89, 152); line-height: 16px; height: 16px; width: 16px;"><svg
                          xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
                          viewBox="0 0 32 32" version="1.1" role="img" aria-labelledby="at-svg-facebook-1"
                          title="Facebook" alt="Facebook" style="width: 16px; height: 16px;"
                          class="at-icon at-icon-facebook">
                          <title id="at-svg-facebook-1">Facebook</title>
                          <g>
                            <path
                              d="M22 5.16c-.406-.054-1.806-.16-3.43-.16-3.4 0-5.733 1.825-5.733 5.17v2.882H9v3.913h3.837V27h4.604V16.965h3.823l.587-3.913h-4.41v-2.5c0-1.123.347-1.903 2.198-1.903H22V5.16z"
                              fill-rule="evenodd"></path>
                          </g>
                        </svg>
                      </span>
                    </a>
                  </li>
                  <li><a shareButton="twitter" data-original-title="twitter"
                      class="jobsearch-icon jobsearch-twitter-circular-button addthis_button_twitter at300b"
                      title="Twitter"><span class="at-icon-wrapper"
                        style="background-color: rgb(29, 161, 242); line-height: 16px; height: 16px; width: 16px;"><svg
                          xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
                          viewBox="0 0 32 32" version="1.1" role="img" aria-labelledby="at-svg-twitter-2"
                          title="Twitter" alt="Twitter" style="width: 16px; height: 16px;"
                          class="at-icon at-icon-twitter">
                          <title id="at-svg-twitter-2">Twitter</title>
                          <g>
                            <path
                              d="M27.996 10.116c-.81.36-1.68.602-2.592.71a4.526 4.526 0 0 0 1.984-2.496 9.037 9.037 0 0 1-2.866 1.095 4.513 4.513 0 0 0-7.69 4.116 12.81 12.81 0 0 1-9.3-4.715 4.49 4.49 0 0 0-.612 2.27 4.51 4.51 0 0 0 2.008 3.755 4.495 4.495 0 0 1-2.044-.564v.057a4.515 4.515 0 0 0 3.62 4.425 4.52 4.52 0 0 1-2.04.077 4.517 4.517 0 0 0 4.217 3.134 9.055 9.055 0 0 1-5.604 1.93A9.18 9.18 0 0 1 6 23.85a12.773 12.773 0 0 0 6.918 2.027c8.3 0 12.84-6.876 12.84-12.84 0-.195-.005-.39-.014-.583a9.172 9.172 0 0 0 2.252-2.336"
                              fill-rule="evenodd"></path>
                          </g>
                        </svg></span></a>
                  </li>
                  <li><a shareButton="linkedin" data-original-title="linkedin"
                      class="jobsearch-icon jobsearch-linkedin addthis_button_linkedin at300b" target="_blank"
                      title="LinkedIn"><span class="at-icon-wrapper"
                        style="background-color: rgb(0, 119, 181); line-height: 16px; height: 16px; width: 16px;"><svg
                          xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
                          viewBox="0 0 32 32" version="1.1" role="img" aria-labelledby="at-svg-linkedin-3"
                          title="LinkedIn" alt="LinkedIn" style="width: 16px; height: 16px;"
                          class="at-icon at-icon-linkedin">
                          <title id="at-svg-linkedin-3">LinkedIn</title>
                          <g>
                            <path
                              d="M26 25.963h-4.185v-6.55c0-1.56-.027-3.57-2.175-3.57-2.18 0-2.51 1.7-2.51 3.46v6.66h-4.182V12.495h4.012v1.84h.058c.558-1.058 1.924-2.174 3.96-2.174 4.24 0 5.022 2.79 5.022 6.417v7.386zM8.23 10.655a2.426 2.426 0 0 1 0-4.855 2.427 2.427 0 0 1 0 4.855zm-2.098 1.84h4.19v13.468h-4.19V12.495z"
                              fill-rule="evenodd"></path>
                          </g>
                        </svg></span></a>
                  </li>
                </ul>
              </figcaption>
            </figure>
          </div>
        </div>


        <div class="jobsearch-column-8 jobsearch-typo-wrap">
          <div class="jobsearch-jobdetail-content">
            <div class="jobsearch-content-title">
              <h2>Job Detail</h2>
            </div>

            <div class="jobsearch-jobdetail-services">
              <ul class="jobsearch-row">
                <li class="jobsearch-column-4"> <i class="jobsearch-icon jobsearch-network"></i>
                  <div class="jobsearch-services-text">Industry <small>{{job.job_industry}}</small></div>
                </li>
                <li class="jobsearch-column-4"> <i class="jobsearch-icon jobsearch-briefcase"></i>
                  <div class="jobsearch-services-text">Experience <small>{{job.experience}}</small></div>
                </li>
                <li class="jobsearch-column-4"> <i class="jobsearch-icon jobsearch-salary"></i>
                  <div class="jobsearch-services-text">Salary (£) <small>{{job.salary ? (job.salary | number) :
                      'Competitive'}}</small></div>
                </li>
              </ul>
            </div>

            <div class="jobsearch-content-title">
              <h2>Job Description</h2>
            </div>

            <div class="jobsearch-description">
              <section class="default-component grey careers-full-width">
                <div class="student-program-info">
                  <div [innerHTML]="job.description">
                  </div>
                </div>
              </section>
            </div>

            <ng-container *ngIf="job.attachment">
              <div class="jobsearch-content-title">
                <h2>Attachment</h2>
              </div>

              <div class="job-attachment">
                <a href="{{job.attachment | fileSrc: 'job'}}">
                  <i class="fa fa-paperclip"></i>
                  <span>{{job.attachment}}</span>
                </a>
              </div>
            </ng-container>
          </div>

          <div class="jobsearch-section-title" *ngIf="otherJobs?.length">
            <h2>Other jobs you may like</h2>
          </div>
          <div class="jobsearch-job jobsearch-joblisting-classic jobsearch-jobdetail-joblisting">
            <ul class="jobsearch-row">
              <li class="jobsearch-column-12" *ngFor="let otherJob of otherJobs">
                <div class="jobsearch-joblisting-classic-wrap">
                  <figure>
                    <a [routerLink]="['/jobs/details', otherJob.slug]">
                      <img [src]="otherJob.user_profile_photo | imageSrc: 'users'" alt="">
                    </a>
                  </figure>
                  <div class="jobsearch-joblisting-text">
                    <div class="jobsearch-list-option">
                      <h2 class="jobsearch-pst-title">
                        <a [routerLink]="['/jobs/details', otherJob.slug]" [title]="otherJob.title">
                          {{otherJob.title}} </a>
                      </h2>

                      <ul>
                        <li><a [routerLink]="['/user-details', otherJob.username]">@
                            {{otherJob.user_display_name}}</a></li>

                        <li><i class="jobsearch-icon jobsearch-filter-tool-black-shape"></i>
                          <a [routerLink]="['/jobs']" [queryParams]="{sector: otherJob.job_sector_id}" class=""
                            [innerHTML]="otherJob.job_sector"></a>
                        </li>
                      </ul>
                    </div>

                    <div class="jobsearch-job-userlist">
                      <a class="jobsearch-option-btn" [class]="otherJob.job_type">
                        {{getJobType(otherJob)}} </a>
                      <div class="like-btn ">
                        <a (click)="updateFavoriteJob(otherJob)"
                          class="shortlist jobsearch-add-job-to-favourite jobsearch-job-like"
                          [ngClass]="{'jobsearch-job-favorite': isFavoriteJob(otherJob)}">
                          <i class="jobsearch-icon jobsearch-heart"></i>
                        </a>
                        <span class="job-to-fav-msg-con"></span>
                      </div>
                    </div>
                    <div class="clearfix"></div>
                  </div>
                </div>
              </li>
            </ul>
          </div>
        </div>


        <aside class="jobsearch-column-4 jobsearch-typo-wrap">
          <div class="jobsearch_side_box jobsearch_apply_job">
            <div class="jobsearch_apply_job_wrap">
              <ng-container *ngIf="job.filled">
                <span>Job application is filled.</span>
              </ng-container>

              <ng-container *ngIf="!job.filled">
                <ng-container *ngIf="!isDeadlineOver(job)">
                  <ng-container *ngIf="!applied">
                    <a (click)="applyForJob()" class="jobsearch-applyjob-btn">Apply for
                      the job</a>
                    <span>Application ends in {{job.deadline | timeUntil}}</span>
                  </ng-container>

                  <ng-container *ngIf="applied">
                    <span>You have applied for this job.</span>
                  </ng-container>
                </ng-container>
                <ng-container *ngIf="isDeadlineOver(job)">
                  <span>Application deadline has ended.</span>
                </ng-container>
              </ng-container>
            </div>
            <a (click)="openContactEmployerModal()"
              class="jobsearch-sendmessage-btn jobsearch-sendmessage-messsage-popup-btn"><i
                class="jobsearch-icon jobsearch-envelope"></i> Contact Employer</a>
          </div>
          <div class="jobsearch_side_box jobsearch_box_map">
            <div class="jobsearch-map">
              <div id="googleMap" style="width:100%;height:300px;"></div>
            </div>
          </div>

          <div class="jobsearch_side_box jobsearch_box_view_jobs" *ngIf="userJobs?.length">
            <div class="jobsearch-wdg-box-title">
              <h2>More Jobs From {{job.user?.display_name}}</h2>
            </div>

            <ul>
              <li *ngFor="let userJob of userJobs">
                <h2 class="jobsearch-pst-title">
                  <a [routerLink]="['/job/details', userJob.slug]" title="{{userJob.title}}">
                    {{userJob.title}} </a>
                </h2>

                <span>
                  <a [routerLink]="['/jobs']" [queryParams]="{sector: userJob.job_sector_id}" class=""
                    [innerHTML]="userJob.job_sector">
                  </a>
                </span>

                <small>{{userJob.address}}</small>
              </li>
            </ul>
            <a [routerLink]="['/user-details', job.user.username]" class="jobsearch_box_view_jobs_btn">View all jobs <i
                class="jobsearch-icon jobsearch-arrows32"></i></a>
          </div>
        </aside>

      </div>
    </div>
  </div>

</div>